module.exports = __webpack_public_path__ + "static/media/10.82fafba5.JPG";